
<div class="menu">
    <template v-for="(n, i) in nav">
        <button
            v-if="n.scrollTo"
            :key="'nav-' + i"
            v-scroll-to="n.scrollTo"
            type="button"
            class="btn btn-block"
            :class="{ active: current == i }"
            @click="() => $emit('force-nav', i)"
        >
            {{ n.label }}
        </button>
        <router-link
            v-else-if="n.to"
            :key="'nav-' + i"
            :to="n.to"
            class="btn btn-block"
            tag="button"
            :class="{ active: current == i }"
        >
            {{ n.label }}
        </router-link>

        <button :key="'nav-' + i" v-else type="button" class="btn btn-block premium" disabled>
            <span class="blurry-light">{{ n.label }}</span>
            <PremiumLabel />
        </button>
    </template>
</div>
